import React from 'react';

interface LoadingStateProps {
  isMimicking: boolean;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ isMimicking }) => {
  return (
    <div
      className={`min-h-screen flex items-center justify-center bg-gray-50 ${
        isMimicking ? 'mt-[52px]' : ''
      }`}
    >
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Loading preview...</p>
      </div>
    </div>
  );
};
